import type { ErrorData } from '../../@types/vendors/vkbridge';
import { Result } from '../../assets/src/utils/Result';
import { assertNever } from '../../assets/src/utils/assert-never';
import { Deferred, deferred } from '../../assets/src/utils/deferred';
import { IPlatformPreloader, loadScriptWithRetries } from './IPlatformPreloader';

export class VkPlatformPreloader implements IPlatformPreloader {
	private _initialized = false;
	private _complete: Deferred<Result>;

	public get initialized(): boolean {
		return this._initialized;
	}

	public set initialized(value: boolean) {
		this._initialized = value;
	}

	public async loadAndInit(): Promise<Result> {
		if (this._complete) {
			return this._complete.promise;
		}

		this._complete = deferred<Result>();

		// TODO try to load from unpkg.com first and fallback to local script
		const scriptUrl = 'vk-bridge.min.js';
		const scriptLoaded = await loadScriptWithRetries(scriptUrl);
		if (scriptLoaded.success === false) {
			this._complete.resolve(Result.Error('failed on script load'));
			return this._complete.promise;
		}

		if (!vkBridge) {
			this._complete.resolve(Result.Error(`'vkBridge' is not available`));
			return this._complete.promise;
		}

		vkBridge
			.send('VKWebAppInit')
			.then(({ result }) => {
				// @link https://dev.vk.com/ru/bridge/VKWebAppInit#%D0%9E%D0%B1%D1%8A%D0%B5%D0%BA%D1%82%20Promise
				if (!result) console.warn('VKWebAppInit returned false');
				this._complete.resolve(Result.Ok());
			})
			.catch((error) => {
				this._complete.resolve(Result.Error(`failed on init (${this.getVkErrorText(error)})`));
			});

		return this._complete.promise;
	}

	// it doesn't work for some reason
	/* private initWithRetries(maxAttempts = 3, attempt = 1, complete = deferred<Result>()): AsyncResult {
		console.log(`platform init#${attempt} - start`);

		vkBridge
			.send('VKWebAppInit')
			.then((data) => {
				if (data.result) {
					console.log(`platform init#${attempt} - complete`);
					complete.resolve(Result.Ok());
				} else {
					const isLastAttempt = attempt === maxAttempts;
					if (isLastAttempt) {
						const errorText = `VKWebAppInit has failed`;
						console.log(`platform init#${attempt} - failed (${errorText})`);
						complete.resolve(Result.Error(errorText));
					} else {
						this.initWithRetries(maxAttempts, attempt + 1, complete);
					}
				}
			})
			.catch((error: ErrorData) => {
				const isLastAttempt = attempt === maxAttempts;
				if (isLastAttempt) {
					const errorText = this.getVkErrorText(error);
					console.log(`platform init#${attempt} - failed (${errorText})`);
					complete.resolve(Result.Error(errorText));
				} else {
					this.initWithRetries(maxAttempts, attempt + 1, complete);
				}
			});

		return complete.promise;
	} */

	private getVkErrorText(error: ErrorData): string {
		switch (error.error_type) {
			case 'api_error':
				return error.error_data.error_msg;
			case 'client_error':
				return error.error_data.error_reason;
			case 'auth_error':
				return error.error_data.error_reason;
			default:
				assertNever(error, 'Unknown VK error!');
		}
	}

	public setLoadingProgress(progress: number): void {
		// ничего не делаем, используется в платформах, где есть свой загрузчик
	}
}
